import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import { CiGrid41 } from 'react-icons/ci';
import { TbApps } from "react-icons/tb";
import { RiAppsLine, RiApps2Line } from "react-icons/ri";
import { showInfoMessage } from '@minohealth/common/utils';

/**
 * Apps section component for sidebar
 * Contains PACS and CRM links/buttons
 */
export default function AppsList() {
    const [isExpanded, setIsExpanded] = useState(false);

    const handleCRMClick = () => {
        showInfoMessage('CRM feature coming soon!');
    };

    return (
        <div className="space-y-1 mb-2">
            {/* Apps Header - Collapsible */}
            <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="w-full flex items-center justify-between px-2 py-2 text-sm font-medium text-foreground hover:text-foreground transition-colors bg-transparent group"
            >
                <div className="flex items-center gap-2">
                    <RiApps2Line className="w-4 h-4 transition-all duration-200 group-hover:scale-110 group-hover:opacity-0 absolute" />
                    <RiAppsLine className="w-4 h-4 text-muted-foreground transition-all duration-200 opacity-0 group-hover:opacity-100 group-hover:scale-110" />
                    <span className="font-medium">Apps</span>
                </div>
                {isExpanded ? (
                    <FaChevronDown className="w-3 h-3 transition-transform duration-200" />
                ) : (
                    <FaChevronRight className="w-3 h-3 transition-transform duration-200" />
                )}
            </button>

            {/* Apps List */}
            {isExpanded && (
                <div className="space-y-1 px-2">
                    {/* PACS Link */}
                    <Link
                        to="/anokye/report-history"
                        className="flex items-center gap-2 px-2 h-9 text-sm text-foreground bg-transparent hover:bg-muted rounded-lg transition-colors group"
                    >
                        <CiGrid41 className="w-4 h-4 transition-transform duration-200 group-hover:scale-110" />
                        <span className="font-medium">PACS</span>
                    </Link>

                    {/* CRM Button (Coming Soon) */}
                    <button
                        onClick={handleCRMClick}
                        className="w-full flex items-center gap-2 px-2 h-9 text-sm text-foreground bg-transparent hover:bg-muted rounded-lg transition-colors group"
                    >
                        <svg
                            className="w-4 h-4 transition-transform duration-200 group-hover:scale-110"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                            />
                        </svg>
                        <span className="font-medium">CRM</span>
                        <span className="ml-auto text-xs text-muted-foreground">Soon</span>
                    </button>
                </div>
            )}
        </div>
    );
}
